// Informativa Privacy (GDPR) — BOZZA da revisione legale prima del go-live.
import LegalLayout from "@/components/LegalLayout";
import { Seo } from "@/components/public/Seo";
import publicContent from "@/pages/public/publicContent.json";

const PRIVACY_SEO = publicContent.routes.find((r) => r.path === "/privacy");

export default function Privacy() {
  return (
    <LegalLayout title="Informativa sulla Privacy" updatedAt="giugno 2026"
      testId="privacy-page">
      <Seo title={PRIVACY_SEO.title} description={PRIVACY_SEO.description} path="/privacy" />
      <section>
        <h2 className="text-lg font-bold text-slate-900">1. Titolare del trattamento</h2>
        <p>Il Titolare del trattamento dei dati personali è [DENOMINAZIONE TITOLARE],
        con sede in [INDIRIZZO], contattabile all'indirizzo email [EMAIL PRIVACY].
        Il Titolare ha nominato un Responsabile per la protezione dei dati (DPO)? [SÌ/NO — DA DEFINIRE].</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">2. Dati raccolti</h2>
        <p>La piattaforma raccoglie: (a) dati anagrafici dell'account (nome, email,
        credenziali cifrate); (b) dati aziendali inseriti per la rendicontazione ESG
        secondo lo standard VSME; (c) documenti caricati dall'utente come evidenze;
        (d) dati aggregati sul personale (mai dati individuali sanitari o categorie
        particolari ex art. 9 GDPR); (e) log di audit e di accesso per finalità di
        sicurezza; (f) contenuti delle interazioni con l'assistente AI Eva.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">3. Finalità e base giuridica</h2>
        <p>I dati sono trattati per: erogazione del servizio SaaS di rendicontazione
        ESG (esecuzione del contratto, art. 6.1.b GDPR); adempimenti di legge
        (art. 6.1.c); sicurezza della piattaforma e prevenzione degli abusi
        (legittimo interesse, art. 6.1.f); miglioramento del servizio in forma
        aggregata e anonimizzata.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">4. Condivisione controllata (Data Room)</h2>
        <p>I contenuti ESG sono condivisi con terzi (es. banche, clienti, auditor)
        esclusivamente su iniziativa dell'utente tramite Data Room con link monouso,
        scadenza automatica, tracciamento degli accessi e revoca immediata. Nessun
        dato è ceduto o venduto a terzi per finalità proprie.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">5. Trattamenti automatizzati e AI</h2>
        <p>L'assistente Eva elabora i dati aziendali per fornire risposte contestuali.
        I dati non sono utilizzati per addestrare modelli di terze parti. Le azioni
        ad alto impatto richiedono sempre conferma umana esplicita. [CONFERMARE
        INFORMATIVA ART. 22 GDPR CON IL LEGALE]</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">6. Conservazione</h2>
        <p>I dati sono conservati per la durata del contratto e, dopo la cessazione,
        per [PERIODO — DA DEFINIRE, es. 12 mesi] per consentire l'esportazione, salvo
        obblighi di legge diversi. I backup sono conservati per [PERIODO BACKUP — DA DEFINIRE].</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">7. Diritti dell'interessato</h2>
        <p>Puoi esercitare i diritti di accesso, rettifica, cancellazione, limitazione,
        portabilità e opposizione (artt. 15-22 GDPR) scrivendo a [EMAIL PRIVACY].
        Hai diritto di reclamo al Garante per la protezione dei dati personali.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">8. Sub-responsabili e trasferimenti</h2>
        <p>Elenco dei sub-responsabili (hosting, provider AI, storage): [ELENCO — DA COMPILARE].
        Eventuali trasferimenti extra-UE avvengono nel rispetto del Capo V GDPR
        [VERIFICARE CLAUSOLE CON IL LEGALE].</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">9. Cookie</h2>
        <p>La piattaforma utilizza esclusivamente cookie tecnici httpOnly necessari
        all'autenticazione e alla sicurezza della sessione. Non sono impiegati cookie
        di profilazione o di terze parti. [VERIFICARE CON IL LEGALE]</p>
      </section>
    </LegalLayout>
  );
}
